import { useLayoutEffect } from 'react'

const $body = document.body

export const useBodyClass = (className: string, force: boolean) => {
	useLayoutEffect(() => {
		$body.classList.toggle(className, force)
	}, [force])
}
